import { PRE_SIGN_PARAMS, REQUIRED_PRESIGN_PARAMS } from '@/shared/config';

// A basic presigned patient URL (all required X-Dc-* params, not scoped to a
// report) is how an external MIS deep-links a doctor into the recording flow,
// per the partner Transcriptor quick start guide. Report-scoped presigns are
// unrelated integrations and must not trigger the recording modal.
export const getPresignDeepLinkSignature = (
  searchParams: URLSearchParams,
): string | null => {
  const hasAllRequiredParams = REQUIRED_PRESIGN_PARAMS.every((param) =>
    searchParams.get(param),
  );

  if (!hasAllRequiredParams || searchParams.get(PRE_SIGN_PARAMS.reportID)) {
    return null;
  }

  return searchParams.get(PRE_SIGN_PARAMS.signature);
};
